/** Tinted icon-tile colours used by hero tiles, category tiles and service lists. */
export const TILE_TONES: Record<string, string> = {
  orange: 'bg-orange-50 text-orange-600 ring-orange-100',
  red: 'bg-rose-50 text-rose-600 ring-rose-100',
  blue: 'bg-brand-50 text-brand-600 ring-brand-100',
  violet: 'bg-violet-50 text-violet-600 ring-violet-100',
  amber: 'bg-amber-50 text-amber-600 ring-amber-100',
  green: 'bg-emerald-50 text-emerald-600 ring-emerald-100',
  navy: 'bg-indigo-50 text-indigo-700 ring-indigo-100',
  pink: 'bg-pink-50 text-pink-600 ring-pink-100',
  cyan: 'bg-cyan-50 text-cyan-600 ring-cyan-100',
};
export const TONE_ORDER = ['blue', 'orange', 'red', 'violet', 'green', 'amber', 'navy', 'pink', 'cyan'];
export const toneAt = (i: number) => TILE_TONES[TONE_ORDER[i % TONE_ORDER.length]];
export const tone = (c?: string, i = 0) => TILE_TONES[c ?? ''] ?? toneAt(i);
